import Component from '../core/Component'

export default class CourseInstructionsToggle extends Component {

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        event.preventDefault()

        const id = this.element.getAttribute('href').split('#')[1]

        const instructions = Component.getFromElement(id)

        if (instructions) {
            instructions.toggle()
        }
    }
}